<template>
  <div class="flex flex-col" :class="[theme.container, containerClass]">
    <p
      :class="[theme.overline, overlineClass]"
      v-if="overline"
      v-html="overline"
    ></p>

    <h1 :class="[theme.title, titleClass]" v-if="title" v-html="title"></h1>

    <h3
      :class="[theme.subtitle, subtitleClass]"
      v-if="subtitle"
      v-html="subtitle"
    ></h3>

    <p
      :class="[theme.description, descriptionClass]"
      v-if="description"
      v-html="description"
    ></p>

    <div v-if="blocks?.length" :class="['mt-4 space-y-4', blocksClass]">
      <component
        v-for="(block, idx) in blocks"
        :key="idx"
        :is="block.component"
        v-bind="block.props || {}"
      />
    </div>
  </div>
</template>

<script setup>
import { infoBlockTheme } from './scripts/themeHelpers';


const props = defineProps({
  overline: { type: String, default: '' },
  title: { type: String, default: '' },
  subtitle: { type: String, default: '' },
  description: { type: String, default: '' },
  blocks: { type: Array, default: () => [] },
  variant: { type: String, default: 'default' },
  containerClass: { type: String, default: '' },
  overlineClass: { type: String, default: '' },
  titleClass: { type: String, default: '' },
  subtitleClass: { type: String, default: '' },
  descriptionClass: { type: String, default: '' },
  blocksClass: { type: String, default: '' },
})

const theme = infoBlockTheme(props.variant)
</script>

<style scoped>
/* Styles spécifiques si nécessaire */
</style>
